const RedirectToOldCongrant = () => {
  const usp = new URLSearchParams(window.location.search);
  window.location.href = `https://cg0ld.congrant.com/new/receipt-mail?${usp}`;
  return null;
};

export default RedirectToOldCongrant;
